import React, { useState, useEffect } from 'react';
import { Icon } from '@shopify/polaris';
import { DeleteMinor } from '@shopify/polaris-icons';
import CTableCell from '@admin/pages/Chart/CTableCell';
import {Cell} from "@admin/types";


interface TableDataProps {
    tableData: Cell[][];
    headers: {
        top?: boolean;
        bottom?: boolean;
        left?: boolean;
        right?: boolean;
    };
    onChange: (table: Cell[][]) => void;
}

function CTableEditor({tableData, headers, onChange}: TableDataProps) {

    const [table, setTable] = useState<Cell[][]>([]);
    const [popoverActive, setPopoverActive] = useState(false);

    useEffect(() => {
        setTable(tableData);
    }, [tableData]);

    const addRow = (index: number) => {
        if(!popoverActive){
            const newRow = Array(table[0].length).fill({ type: 'text', value: '' });
            const updatedTable = [...table.slice(0, index + 1), newRow, ...table.slice(index + 1)];
            setTable(updatedTable);
            onChange(updatedTable);
        }else{
            console.log('Cannot add row, popover active')
        }
    };

    const deleteRow = (index: number) => {
        const updatedTable = [...table.slice(0, index), ...table.slice(index + 1)];
        setTable(updatedTable);
        onChange(updatedTable);
    };

    const addColumn = (index: number) => {
        const updatedTable = table.map((row) => [
            ...row.slice(0, index + 1),
            { type: 'text', value: '' },
            ...row.slice(index + 1),
        ]);
        setTable(updatedTable);
        onChange(updatedTable);
    };

    const deleteColumn = (index: number) => {
        const updatedTable = table.map((row) => [...row.slice(0, index), ...row.slice(index + 1)]);
        setTable(updatedTable);
        onChange(updatedTable);
    };

    const isPopoverActive = (status: boolean) => {
        setPopoverActive(status);
    };

    const isHeader = (i: number, j: number): boolean => {
        const isTop = i === 0;
        const isBottom = i === table.length - 1;
        const isLeft = j === 0;
        const isRight = j === table[0].length - 1;

        return ((isTop && headers.top) ||
            (isBottom && headers.bottom) ||
            (isLeft && headers.left) ||
            (isRight && headers.right)) || false;
    };


    return (
        <div className="c-table-editor">
            {(table && table.length > 0) && (
                <table className="c-table-editor__table">
                    <tbody>
                    {!popoverActive &&
                        <tr>
                        <td
                            colSpan={table[0].length === 1 ? table[0].length : table[0].length * 2}
                            className="c-table-editor__separator-r c-table-editor__separator-r--top"
                            onClick={() => addRow(-1)}
                        >
                            <div className="c-table-editor__separator-r__content c-table-editor__separator-r__content--top" />
                        </td>
                    </tr>
                    }
                    {popoverActive &&
                        <tr>
                            <td
                                colSpan={table[0].length === 1 ? table[0].length : table[0].length * 2}
                                className=""
                                style={{height:'10px'}}
                            >
                                <div className="c-table-editor_blank" />
                            </td>
                        </tr>
                    }
                    {table.map((row, i) => (
                        <React.Fragment key={i}>
                            <tr>
                                {row.map((column, j) => (
                                    <React.Fragment key={j}>
                                        {i === 0 && j === 0 && (
                                            <td
                                                rowSpan={table.length * 2 + 1}
                                                className="c-table-editor__separator-c"
                                                onClick={() => addColumn(-1)}
                                            >
                                                <div className="c-table-editor__separator-c__content" />
                                            </td>
                                        )}
                                        <td className="c-table-editor__data">
                                            <CTableCell isPopoverActive={isPopoverActive} isHeader={isHeader(i, j)} cell={column} onChange={(v) => {
                                                const newTable = [...table];
                                                newTable[i][j] = v;
                                                setTable(newTable);
                                                onChange(newTable);
                                            }} />
                                        </td>
                                        {i === 0 && (
                                            <td
                                                rowSpan={table.length * 2 + 1}
                                                className="c-table-editor__separator-c"
                                                onClick={() => addColumn(j)}
                                            >
                                                <div className="c-table-editor__separator-c__content" />
                                            </td>
                                        )}
                                    </React.Fragment>
                                ))}
                                {table.length > 1 && (
                                    <td className="c-table-editor__delete-r" onClick={() => deleteRow(i)}>
                                        <Icon source={DeleteMinor} /><span>Remove row</span>
                                    </td>
                                )}
                            </tr>
                            {!popoverActive &&
                                <tr>
                                    <td
                                        colSpan={table[0].length === 1 ? table[0].length : table[0].length * 2}
                                        className="c-table-editor__separator-r"
                                        onClick={() => addRow(i)}
                                    >
                                        <div className="c-table-editor__separator-r__content"/>
                                    </td>
                                </tr>
                            }
                            {popoverActive &&
                                <tr>
                                    <td
                                        colSpan={table[0].length === 1 ? table[0].length : table[0].length * 2}
                                        className=""
                                        style={{height:'10px'}}
                                    >
                                      <div className="c-table-editor_blank" />
                                    </td>
                                </tr>
                            }
                        </React.Fragment>
                    ))}
                    <tr>
                        {table[0].length > 1 && table[0].map((_, j) => (
                            <td key={j} className="c-table-editor__delete-c" onClick={() => deleteColumn(j)}>
                                <div className="inline-flex-center">
                                    <Icon source={DeleteMinor}/><span>Remove column</span>
                                </div>
                            </td>
                        ))}
                    </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default CTableEditor;
